// extracted by mini-css-extract-plugin
module.exports = {"loginBtn":"Auth_loginBtn__RQWWs","loginBtnfacebook":"Auth_loginBtnfacebook__3HlfE","loginBtngoogle":"Auth_loginBtngoogle__1-Hto","Modal":"Auth_Modal__20TVB"};